interface Feature {
  icon?: string;
  title: string;
  description?: string;
}

interface FeatureGridProps {
  title?: string;
  subtitle?: string;
  columns?: 2 | 3 | 4;
  features?: Feature[];
}

const COLS: Record<number, string> = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
};

export function FeatureGridBlock({ props }: { props: FeatureGridProps }) {
  const cols = props.columns ?? 3;
  const features = props.features ?? [];

  return (
    <div className="py-8 px-4">
      {(props.title || props.subtitle) && (
        <div className="text-center mb-8">
          {props.title && (
            <h2 className="text-2xl sm:text-3xl font-bold text-zinc-900 mb-2">{props.title}</h2>
          )}
          {props.subtitle && <p className="text-zinc-500 text-base">{props.subtitle}</p>}
        </div>
      )}
      {features.length > 0 && (
        <div className={`grid grid-cols-1 gap-6 ${COLS[cols] ?? COLS[3]}`}>
          {features.map((f, i) => (
            <div key={i} className="flex flex-col gap-2 p-5 rounded-xl border border-zinc-100 bg-white shadow-sm">
              {f.icon && <span className="text-2xl leading-none">{f.icon}</span>}
              <h3 className="font-semibold text-zinc-800 text-base">{f.title}</h3>
              {f.description && <p className="text-sm text-zinc-500 leading-relaxed">{f.description}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
